import { BoardValue } from '../../jscaip/AI/BoardValue';
import { PlayerMetricHeuristicWithBounds } from '../../jscaip/AI/Minimax';
import { Player } from '../../jscaip/Player';
import { PlayerNumberMap } from '../../jscaip/PlayerMap';
export class TaflPieceHeuristic extends PlayerMetricHeuristicWithBounds {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getMetrics(node, config) {
        const state = node.gameState;
        // We just count the pawns
        const zeroPawnsCount = this.rules.getPlayerListPawns(Player.ZERO, state).length;
        const onePawnsCount = this.rules.getPlayerListPawns(Player.ONE, state).length;
        return this.getHeuristicValue(config, zeroPawnsCount, onePawnsCount).toTable();
    }
    getHeuristicValue(config, zeroPawnsCount, onePawnsCount) {
        const invader = this.rules.getInvader(config);
        const scoreZero = this.getScoreFor(Player.ZERO, invader, zeroPawnsCount);
        const scoreOne = this.getScoreFor(Player.ONE, invader, onePawnsCount);
        return PlayerNumberMap.of(scoreZero, scoreOne);
    }
    getScoreFor(player, invader, pawnsCount) {
        // Invaders pieces are twice as numerous, so they are twice less valuable
        let mult;
        if (player === Player.ZERO) {
            if (invader === Player.ZERO) {
                mult = 1;
            }
            else {
                mult = 2;
            }
        }
        else {
            if (invader === Player.ZERO) {
                mult = 2;
            }
            else {
                mult = 1;
            }
        }
        return pawnsCount * mult;
    }
    getBounds(config) {
        // For the maximum, we consider the game of hnefatafl which has 24 pieces and 13
        // Another option would be to define a heuristic that is mostly copy-pasted from this, but in each tafl games
        // In the end, what we care about is "bigger metric = better", not that it is 100% accurate
        const maxPawns = PlayerNumberMap.of(24, 13);
        const invader = this.rules.getInvader(config);
        const zeroPawnsCount = maxPawns.get(invader);
        const onePawnsCount = maxPawns.get(invader.getOpponent());
        const player0HeuristicValue = this.getHeuristicValue(config, zeroPawnsCount, 0);
        const player0Best = BoardValue.ofPlayerNumberMap(player0HeuristicValue);
        const player1HeuristicValue = this.getHeuristicValue(config, 0, onePawnsCount);
        const player1Best = BoardValue.ofPlayerNumberMap(player1HeuristicValue);
        return { player0Best, player1Best };
    }
}
